/**
 * Cloud upload icon for UploadDownloadArea (Figma design).
 * SVG converted from Figma; fill uses color prop or white.
 */

import React from "react";
import type { IconProps } from "./types";

const VIEWBOX_WIDTH = 44;
const VIEWBOX_HEIGHT = 45;

const CloudUploadIcon: React.FC<IconProps> = ({
  size = 44,
  color = "#ffffff",
  ...props
}) => (
  <svg
    width={size}
    height={size * (VIEWBOX_HEIGHT / VIEWBOX_WIDTH)}
    viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.028 29.006a1.354 1.354 0 011.945 0l3.666 3.75a1.43 1.43 0 010 1.988c-.537.55-1.407.55-1.944 0l-1.32-1.349v7.855c0 .777-.615 1.406-1.375 1.406s-1.375-.63-1.375-1.406v-7.855l-1.32 1.35c-.536.549-1.407.549-1.944 0a1.429 1.429 0 010-1.99l3.667-3.75z"
      fill={color}
    />
    <path
      d="M22.873 7.031c-5.042 0-9.1 4.127-9.1 9.182 0 .867.118 1.704.339 2.496a9.144 9.144 0 012.536 1.198c.633.428.807 1.301.388 1.949a1.357 1.357 0 01-1.905.397 6.408 6.408 0 00-3.607-1.104c-3.595 0-6.482 2.941-6.482 6.535 0 3.593 2.887 6.535 6.482 6.535.76 0 1.375.63 1.375 1.406 0 .777-.615 1.406-1.375 1.406-5.083 0-9.232-4.17-9.232-9.347 0-5.07 3.978-9.174 8.916-9.342a12.204 12.204 0 01-.186-2.129c0-6.64 5.321-11.994 11.851-11.994 5.79 0 10.627 4.207 11.652 9.79 4.216 1.83 7.184 6.07 7.184 11.028 0 5.764-4.011 10.559-9.338 11.724-.742.162-1.473-.322-1.632-1.082-.159-.759.314-1.506 1.057-1.669 4.106-.898 7.163-4.586 7.163-8.973 0-4.007-2.547-7.43-6.12-8.678a9.013 9.013 0 00-2.981-.504c-1.069 0-2.09.185-3.04.524a1.368 1.368 0 01-1.75-.864c-.251-.734.127-1.536.844-1.792a11.817 11.817 0 015.544-.573c-1.248-3.557-4.612-6.119-8.583-6.119z"
      fill={color}
    />
  </svg>
);

export default CloudUploadIcon;
